import S from 's-js';
import { IAjax, Request } from 'lib/Ajax';
import { ValidationWatcher } from 'lib/validationWatcher';
import { Entrypoints } from 'core/app/entrypoints';
import { ChangePasswordRequest } from 'data/models/ChangePasswordRequest';

export interface ChangePasswordParams {
    ajax : IAjax;
    entrypoints : Entrypoints;
    userId : number;
    onHidePopup : () => void;
}

export function ChangePassword({ ajax, entrypoints, userId, onHidePopup } : ChangePasswordParams) {
    let url = entrypoints.ChangePassword({ Id: userId }),
        client = ajax.Url<ChangePasswordRequest>(url),
        validation = ValidationWatcher(client),
        changePasswordRequest = new ChangePasswordRequest(),
        httpRequest = S.data<Request<ChangePasswordRequest> | null>(null),
        success = () =>
            httpRequest() && httpRequest()!.Response() && httpRequest()!.Response()!.Success;

    return {
        ChangePasswordRequest: changePasswordRequest,
        Success: success,
        Validation: validation,
        Submit: Submit,
        HidePopup: onHidePopup
    };

    function Submit() {
        httpRequest(client.Post(changePasswordRequest));
    }
}
export type ChangePassword = ReturnType<typeof ChangePassword>;


// WEBPACK FOOTER //
// ./apps/core/changepassword/model.ts